import { Injectable } from '@angular/core';
import { ProductApi } from '../../assets/js/lb-sdk/services';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { Subject, merge } from 'rxjs';

import { HttpClient,HttpResponse,  HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, forkJoin } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { PaymentRequest } from '../interfaces';
import { ProductsService as MaxiProductsService } from  '@app/services/maxi/products.service';

// v15

@Injectable()
export class ProductsService {
  private productTypes;
  private loading = {
    productTypes: false
  };
  productTypesChange: Subject<Array<any>> = new Subject<Array<any>>();

  constructor(
    private productApi: ProductApi,
    private productsService: MaxiProductsService,
    private toast: ToastrService,
    private http: HttpClient
  ) {
    this.productTypesChange.subscribe((value) => {
      this.productTypes = value;
    });
  }

  loadProductTypes() {
    this.loading.productTypes = true;
     
    /*
    this.productsService.findAll()
      .subscribe(value => {
        console.log('prodcutservice value', value)
      })
      */
    /**  For fork join, always make sure 
     * all the observables do not start with empty content
     */
    forkJoin(
      this.productsService.findAll(),
      this.productApi.getTypes({ include: 'products'})
      .pipe(finalize(() => { this.loading.productTypes = false; }))
      )
 
    .subscribe( ([activeInactiveList,response]) => {
      
      /*
      this.productApi.getTypes({ include: 'products'})
      .pipe(finalize(() => { this.loading.productTypes = false; }))
      .subscribe( (response) => {
        */
      this.productTypesChange
        .next(
          response
            .filter(type => type.products && type.products.length)
            // .filter(type => type.name !== 'ZPRM')
            .map(type => {
              type.products = type.products.map(product => {
                var price = parseFloat(product.price || 0);
                product.taxedPrice = (price * 1.12).toFixed(2);                    
          
                
                product.active = this.findActive(
                  activeInactiveList,type.name,
                  product.planTypeCode)
                
                return product;
              });
              return type
            })
        ) }
          ,
        error => {
          this.toast.error(
            'An error occured while fetching the products list. Try to reload the page or contact admin if error persist.',
            'Product List Error'
          );
        }
      );
  }

  
  findActive(list,productType: string,planType: string) {
    const statuses = list.filter(value =>
      value.productType === productType
      && value.planType === planType                        
    )
    return statuses.length === 1 ? statuses[0].active : false
  }

  getProductTypes() {
    return this.productTypes;
  }

  getProductTypeByName(name) {
    return (this.productTypes || [])
      .filter(productType => {
        return productType.name === name;
      })[0];
  }

  getProductByTypeAndPlanCode(productType, planTypeCode) {
    const prodType = this.getProductTypeByName(productType);
    return (prodType && prodType.products || [])
      .filter(product => {
        return product.planTypeCode === planTypeCode;
      })[0]
  }

  
  getActiveProducts() {
    return this.getProducts().filter(product => product.active);
  }
  
  getProducts() {
    return (this.productTypes || []).reduce((products, type) => {
      return products.concat(type.products ? type.products.map(product => {
        product.productType = type;
        return product;
      }) : []);
    }, []).filter(product => {
      return !!product.id;
    });
  }

  isLoading(property?:string):boolean {
    return property ?
      this.loading[property] :
      Object.keys(this.loading).reduce((loading, key):boolean => {
        return loading || this.loading[key];
      }, false);
  }
}
